import { HTML5BackendImpl } from './ba4aad3fc80a92729524e9d1e15b1c683ebfa8641d6e3079a4ab1b947e39101a.cfe-internal.js';
import * as NativeTypes from './03512f1b511823274ab5aaaca673cab282ba69172803d3213ccbf58c3c10c12b.cfe-internal.js';
export { NativeTypes };
export { getEmptyImage } from './a03ffcd48f5ce123bd4987cf25a280214b9f7b03036781e15b1e385bea286436.cfe-internal.js';

var HTML5Backend = function createBackend(manager, context, options) {
  return new HTML5BackendImpl(manager, context, options);
};

export { HTML5Backend };
